import React, { useState, useContext, useEffect, useCallback } from 'react'
import { Container, Modal, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import LoadingOverlay from 'react-loading-overlay'
import PropagateLoader from 'react-spinners/PropagateLoader'
import ReactHotkeys from 'react-hot-keys'

import { ScoreboardData } from '../../Types'

import * as xAPI from '../../api/api'
import { ModuleContext } from '../../contexts/ModuleContext'

import { ButtonGroup, PrimaryButton, SecondaryButton } from '../../styles/Buttons'
import { useTroubleshoot, TroubleshootActionType, TroubleshootAction } from '../../contexts/TroubleshootContext'
import { moduleContent } from '../../Module.config'
import { isDebug } from '../../App.config'
import { TS_Profile } from '../../ModuleTypes'
import { ScoreboardView } from './ScoreboardView'
import NavigationBar from '../NavigationBar'

const Scoreboard: React.FC = () => {
    const context = useContext(ModuleContext)
    const { state, dispatch } = useTroubleshoot()
    const [showFaultSelect, setShowFaultSelect] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const history = useHistory()

    const { user, userProfile } = context
    const profile = userProfile as TS_Profile
    const re = new RegExp('F(00[1-9]|0[1-9][0-9]|[1-9][0-9][0-9]|[A-Z]{3})')

    const onKeyUp = useCallback(() => setShowFaultSelect(true), [])

    const saveFaultId = (faultId: string) => {
        context.faultID = faultId //TODO: This is bad, but needed until Simulation and UnityComponent are converted to Functional Components with hooks.        
        dispatch({ type: TroubleshootActionType.SAVE_FAULT_ID, payload: faultId } as TroubleshootAction)
    }

    const handleClose = (e: React.MouseEvent) => {
        e && e.preventDefault()
        setShowFaultSelect(false)
        setInputValue('')
    }

    const handleSubmit = (event: any) => {
        event && event.preventDefault()
        saveFaultId(inputValue)
        history.push('/workorder')
    }

    const handleClick = (event: any) => {
        event.preventDefault()
        saveFaultId('FRND')
        history.push('/workorder')
    }

    const fetchScoreboard = useCallback(async () => {
        isDebug && console.log(`Fetching Scoreboard values from userprofile`)
        const scoreboardValues: ScoreboardData = await xAPI.getScoreboardValues(user)
        dispatch({ type: TroubleshootActionType.SAVE_SCOREBOARD, payload: scoreboardValues })

    }, [dispatch, user])

    useEffect(() => {
        if (!user.userId || state.scoreboard) return
        fetchScoreboard()
    }, [fetchScoreboard, profile, state.scoreboard, user])

    const TopBar = () => <NavigationBar pageTitle={moduleContent.title} />

    if (!user.userId || !state.scoreboard) {
        const msg = !user.userId ? 'Loading your account' : 'Loading your fault results'
        return (

            <div className="body-override">
                <TopBar />
                <Container className="pre-fault min-specs" fluid={true}>
                    <LoadingOverlay
                        active={!user.userId || !state.scoreboard}
                        spinner={<PropagateLoader color="#f47e56" />}
                        classNamePrefix='loader-'
                        text={msg}
                    />
                </Container>
            </div>
        )
    }

    return (
        <div className="body-override">
            <TopBar />
            <ScoreboardView  {...state.scoreboard} />

            <ButtonGroup>
                <PrimaryButton onClick={() => {
                    history.push('/faulthistory')
                }}>
                    {'View History'}
                </PrimaryButton>

                <SecondaryButton onClick={handleClick}>
                    {'Troubleshoot'}
                </SecondaryButton>
            </ButtonGroup>
            <ReactHotkeys
                keyName="ctrl+shift+f"
                onKeyUp={onKeyUp}
            >
                <Modal
                    show={showFaultSelect}
                    onHide={handleClose}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered={true}
                    className={'SimutechModal'}
                >
                    <Modal.Header closeButton={true}>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {'Fault Selection'}
                        </Modal.Title>
                    </Modal.Header>
                    <form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Form.Label>{'Enter a fault ID'}</Form.Label>
                            <Form.Control
                                type="text"
                                name="fault"
                                maxLength={4}
                                onChange={(e) => setInputValue(e.target.value)}
                                value={inputValue}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <SecondaryButton onClick={handleClose}>{'Cancel'}</SecondaryButton>
                            <PrimaryButton disabled={!re.test(inputValue)} onClick={handleSubmit}>{'Start Fault'}</PrimaryButton>
                        </Modal.Footer>
                    </form>
                </Modal>
            </ReactHotkeys>
        </div>
    )

}

export default Scoreboard


